import React from "react";
import { CalendarBlank } from "@phosphor-icons/react";
import { LEAD_PRESETS } from "../../pages/crm/leadExport";

const inputCls = "h-9 px-2 border border-[#E5E2D9] rounded-md text-sm bg-white";

export const LeadDateFilter = ({ preset, setPreset, custom, setCustom, testPrefix }) => (
  <div className="flex items-center gap-2 flex-wrap" data-testid={`${testPrefix}-date-filter`}>
    <CalendarBlank size={14} className="text-[#5C5A55]" />
    <select value={preset} onChange={(e) => setPreset(e.target.value)} className={inputCls}
            data-testid={`${testPrefix}-date-preset`}>
      {LEAD_PRESETS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
    </select>
    {preset === "custom" && (
      <>
        <input type="date" value={custom.from} max={custom.to || undefined} className={inputCls}
               onChange={(e) => setCustom({ ...custom, from: e.target.value })} data-testid={`${testPrefix}-date-from`} />
        <span className="text-xs text-[#8A8780]">to</span>
        <input type="date" value={custom.to} min={custom.from || undefined} className={inputCls}
               onChange={(e) => setCustom({ ...custom, to: e.target.value })} data-testid={`${testPrefix}-date-to`} />
      </>
    )}
  </div>
);

export const DownloadBtn = ({ onClick, label, testid, disabled }) => (
  <button onClick={onClick} disabled={disabled} data-testid={testid}
          className="h-9 px-3 border border-[#1A1A1A] rounded-md text-xs font-semibold hover:bg-[#1A1A1A] hover:text-white transition-colors disabled:opacity-40">
    {label}
  </button>
);
